import type { ColumnDef } from '@tanstack/react-table';
import { createColumnHelper } from '@tanstack/react-table';
import { Box } from '@mui/material';
import type { ServiceStatusInfo } from '../../types';
import { InfoTooltip } from '../../../../components/InfoTooltip';
import { ServiceStatusCell } from './ServiceStatusCell';
import { RowActions } from './RowActions';
import { ServiceStatus } from '../../types';
import { UI_DATE_FORMAT, toUniversalDate } from '../../../../utils/date.utils';

const columnHelper = createColumnHelper<ServiceStatusInfo>();

export const UNAVAILABLE_PLAN_TOOLTIP =
  'This plan is no longer available. Kindly check our new plans.';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const columns: ColumnDef<ServiceStatusInfo, any>[] = [
  columnHelper.accessor('productFamily.name', {
    id: 'productFamily.name',
    header: 'Service',
    size: 250,
    enableHiding: false,
    enableSorting: false,
    enableResizing: false,
  }),

  columnHelper.accessor('product.name', {
    id: 'product.name',
    header: 'Plan',
    size: 150,
    enableHiding: false,
    enableSorting: false,
    enableResizing: false,
    cell: ({ row }) => {
      const { product } = row.original;

      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {product?.name}
          {!product?.active &&
            row.original.status === ServiceStatus.RequestReceived && (
              <InfoTooltip title={UNAVAILABLE_PLAN_TOOLTIP} />
            )}
        </Box>
      );
    },
  }),

  columnHelper.accessor('status', {
    id: 'status',
    header: 'Status',
    size: 150,
    enableHiding: false,
    enableSorting: false,
    enableResizing: false,
    cell: (props) => <ServiceStatusCell {...props} />,
  }),

  columnHelper.accessor('startDate', {
    id: 'startDate',
    header: 'Start Date',
    size: 50,
    enableHiding: true,
    enableSorting: false,
    enableResizing: false,
    cell: ({ row }) =>
      row?.original?.startDate
        ? toUniversalDate(row.original.startDate, { format: UI_DATE_FORMAT })
        : '--',
  }),

  columnHelper.accessor('endDate', {
    id: 'endDate',
    header: 'End Date',
    size: 50,
    enableHiding: true,
    enableSorting: false,
    enableResizing: false,
    cell: ({ row }) =>
      row?.original?.endDate
        ? toUniversalDate(row.original.endDate, { format: UI_DATE_FORMAT })
        : '--',
  }),

  columnHelper.display({
    id: 'actions',
    header: 'Actions',
    size: 150,
    enableHiding: false,
    enableSorting: false,
    enableResizing: false,
    cell: (props) => <RowActions {...props} />,
  }),
];
